<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'RegisterSuccess',
})
</script>
<template>
  <div class="page">
    <NavBar :title="lang('register_success')" fixed />
    <main class="container">
      <section class="success-section">
        <img class="success-icon" src="@/assets/images/register/success.png" />
        <div class="success-title">{{ lang('register_success_title') }}</div>
        <div
          class="success-desc"
          v-html="lang('register_success_detail')"
        ></div>
        <a class="download-btn" :href="DOWNLOAD_URL" target="_blank">
          {{ lang('download_jt_malaysia_app_now') }}
        </a>
        <div
          class="download-desc"
          v-html="lang('register_download_desc')"
        ></div>
      </section>

      <footer class="footer">
        <img
          class="footer-logo"
          src="@/assets/images/register/footer-logo.png"
        />
        <div class="footer-text">{{ lang('register_footer_text') }}</div>
      </footer>
    </main>
  </div>
</template>

<script setup lang="ts" name="RegisterSuccess">
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'

const DOWNLOAD_URL = 'https://download.jtexpress.my/'
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background-color: #ffffff;
}

.container {
  min-height: 100vh;
  padding: 104px 18px 28px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.success-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success-icon {
  width: 84px;
  height: 84px;
  margin-bottom: 14px;
}

.success-title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  line-height: 28px;
  text-align: center;
}

.success-desc {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #adadad;
  line-height: 22px;
  text-align: center;
}

.download-btn {
  width: 100%;
  height: 44px;
  margin-top: 36px;
  border-radius: 8px;
  background-color: #e60012;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 44px;
  text-align: center;
  text-decoration: none;
}

.download-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #adadad;
  line-height: 22px;
  text-align: center;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo {
  width: 96px;
  height: auto;
}

.footer-text {
  margin-top: 8px;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  text-align: center;
}
</style>
